export default __webpack_public_path__ + "static/media/NoRacesTemplebet.f395971d.png";